<mat-toolbar color="accent" 
            *ngIf="freeTrialActive">
    <span style="font-size: 14px;">This company is part of a free-trial, which ends on {{billingStartDate | date:'EEEE, dd/MM/yyyy'}}</span>
    <span class="example-fill-remaining-space"></span>
    <span>
        <button mat-button [routerLink]="paymentUrl">
            <mat-icon>credit_card</mat-icon>
            Activate your subscription
        </button>
    </span>
</mat-toolbar>
